import React from 'react'
import Berhampore from "../images/berhamporeroom1.jpeg";
import Rooms from "../images/berhamporeroom2.jpeg";
import Lodge from "../images/berhamporeroom3.jpeg";
import Room3 from "../images/lodge.jpeg";
// import Room4 from "../images/room2.jpeg";

function Slider3() {
  return (
    <div>
<div id="carouselExampleCaptions" class="carousel slide" data-bs-ride="carousel">
  <div class="carousel-indicators">
    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="1" aria-label="Slide 2"></button>
    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="2" aria-label="Slide 3"></button>
    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="3" aria-label="Slide 4"></button>

  </div>
  
  <div class="carousel-inner">
    <div class="carousel-item active">
      <img src={Berhampore} class="d-block w-100" alt="Berhampore Lodge"/>
      <div class="carousel-caption d-none d-md-block">
        <h5>Berhampore Lodge</h5>
        <p>Clean Hotel, CCTV Cemera Available, Parking Available</p>
      </div>
    </div>
    <div class="carousel-item">
      <img src={Rooms} class="d-block w-100" alt="Berhampore Lodge"/>
      <div class="carousel-caption d-none d-md-block">
        <h5>Berhampore Lodge</h5>
        <p>Daily Wash, Fress Food, Best Hotel in Berhampore</p>
      </div>
    </div>
    <div class="carousel-item">
      <img src={Lodge} class="d-block w-100" alt="Berhampore Lodge"/>
      <div class="carousel-caption d-none d-md-block">
        <h5>Berhampore Lodge</h5>
        <p> Safe & Secure Hotel in Berhampore</p>
      </div>
    </div>
    <div class="carousel-item">
      <img src={Room3} class="d-block w-100" alt="Berhampore Lodge"/>
      <div class="carousel-caption d-none d-md-block">
        <h5>Berhampore Lodge</h5>
        <p>Ac & Non Ac Room Available, No1 Services</p>
      </div>
    </div>
  </div>
  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
</div>
</div>
  )
}

export default Slider3
